'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = require('lodash');

/**
 * Creates a new object with default values based on the keys passed in.
 * The default values can be set by a function that takes a key and returns a value, or can be constant.
 *
 * <pre>
 *     keysToObject(null, ['a', 'b', 'c']);
 *     // => { a: null, b: null, c: null }
 * </pre>
 */
exports.default = (0, _lodash.curry)(function (defaultValue, keys) {
    var defaultValueFunction = (0, _lodash.isFunction)(defaultValue) ? defaultValue : function (key) {
        return defaultValue;
    };

    return (0, _lodash.zipObject)(keys, (0, _lodash.map)(keys, defaultValueFunction));
}); // Lib


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/milanoteLodash/keysToObject.js
// module id = 762
// module chunks = 0